import { render, staticRenderFns } from "./WarningModal.vue?vue&type=template&id=ba6d9c6c"
import script from "./WarningModal.vue?vue&type=script&lang=ts"
export * from "./WarningModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports